// src/components/Topbar.js
import React, { useEffect, useState } from "react";
import "./Topbar.css";

function Topbar() {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [entityName, setEntityName] = useState("");
  const [online, setOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const e = localStorage.getItem("email");
    const r = localStorage.getItem("role");
    const n = localStorage.getItem("entity_name");

    if (e) setEmail(e);
    if (r) setRole(r);
    if (n) setEntityName(n);
  }, []);

  // Listen for online/offline status
  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const initial = email ? email[0].toUpperCase() : "Q";

  return (
    <div className="topbar glass-topbar">
      {/* LEFT SECTION */}
      <div className="tb-left">
        <div className="tb-entity-label">
          {entityName || "QuickBill Matrix"}
        </div>
      </div>

      {/* CENTER - Status Indicators */}
      <div className="tb-center">
        <div className={`tb-status-pill ${online ? "status-online" : "status-offline"}`}>
          <div className="status-dot"></div>
          {online ? "System Online" : "Connection Lost"}
        </div>
      </div>

      {/* RIGHT: User Profile */}
      <div className="tb-right">
        <div className="tb-user-email">
          {email}
        </div>
      </div>
    </div>
  );
}

export default Topbar;
